import * as React from 'react';
import { cn } from '../lib/cn';

/**
 * Horizontal scroll container for a wide table.
 *
 * A `<table>` with more columns than a phone can show does not wrap — it forces
 * the whole PAGE to scroll sideways, which drags the header and nav off screen
 * and is the single most obvious "this app has no mobile layout" tell. Wrapping
 * the table keeps the overflow inside its own box, so the page itself never
 * scrolls horizontally (the responsive rule every artifact and SPA here
 * follows).
 *
 * Use it around the `<table>` element itself, not around a card.
 */
export function TableScroll({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn('w-full overflow-x-auto', className)}>{children}</div>;
}
